import React from 'react'
import Carousel from 'react-bootstrap/Carousel'
import './BannerCarousel.scss'
import { Image } from 'react-bootstrap'
import { imagesSrc } from './BannerImages'

const BannerCarousel = () => {
  return (
    <Carousel interval={3500} controls={false}>
      {imagesSrc.map((img) => {
        return (
          <Carousel.Item key={img.id}>
            <Image
              className="d-block w-100"
              style={{maxHeight:'75vh'}}
              src={img.src}
              alt={img.name}
            />
          </Carousel.Item>
        )
      })}
    </Carousel>
  )
}

export default BannerCarousel
